import { CompanySelectorBaseDataProvider } from './CompanySelectorBaseDataProvider';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/dashboards/gz-console';
import { sanitizeObject } from '../../utils/sanitization.utils';
import { getRequestDefaultOptions } from '../../utils/request.utils';

export class CompanySelectorNirvanaDataProvider extends CompanySelectorBaseDataProvider {
  async getCompanies(request: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    try {
      const response = await this.dependencies.api.clients.Dashboards.getCompanies(
        {
          companyName: request.companyName,
          params: request.params,
        },
        getRequestDefaultOptions()
      ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      throw new Error(e.message || e);
    }
  }
}
